/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { redirect } from 'react-router-dom';
import Session from 'supertokens-web-js/recipe/session';

export const redirectIfSessionExists = (redirectPath: string) => async () => {
  const session = await Session.doesSessionExist();

  if (session) {
    return redirect(redirectPath);
  }

  return null;
};

export const redirectIfSessionExpired = async () => {
  const session = await Session.doesSessionExist();

  if (!session) {
    return redirect('/login');
  }

  return null;
};

export const sessionGateway =
  ({ ifSessionPath, noSessionPath }: { ifSessionPath: string; noSessionPath: string }) =>
  async () => {
    const session = await Session.doesSessionExist();

    if (session) {
      return redirect(ifSessionPath);
    }

    return redirect(noSessionPath);
  };
